import React, { useEffect, useRef } from 'react';



export interface ISentinelInfiniteScroll {
    fetchMore: () => void
    ref: Element | Document | null
    hasMoreValue: boolean
    rootMargin?: number
}

/**
* @description Cria um observador e executa uma acao quando parte do componente e renderizado.
*
* @param {Function} fetchMore
* @param {Element | Document | null} ref  Referencia HTMLElemnt Lista 
* @param {boolean} hasMoreValue Parametro que indica se ha mais itens para exibir 
* @param {Number} rootMargin Recebe um numero e trasnforma em procentagem e soma + 40%
**/


export const SentinelInfiniteScroll = ({ fetchMore, ref, hasMoreValue, rootMargin }: ISentinelInfiniteScroll) => {
    const containerRef = useRef();

    useEffect(() => {
        const options: IntersectionObserverInit = {
            root: ref || null,
            rootMargin: rootMargin ? `${rootMargin}%` : '80%',
        };

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && hasMoreValue) {
                fetchMore();
            }
        }, options);
        observer.observe(containerRef.current);

        return () => {
            observer.disconnect();
        };
    }, [hasMoreValue]);

    return <div style={{ marginTop: rootMargin ? `-${rootMargin + 40}%` : '-120%' }} ref={containerRef} />;
};
